import type { LabeledStat } from '@/components/common/StatCardGrid';
import { TAKA_SYMBOL } from '@/constants/app.constants';
import type { BudgetTotals } from '../types/marketPromotion.types';

export function getBudgetStatCards(totals: BudgetTotals | undefined): LabeledStat[] {
  return [
    {
      key: 'budget',
      label: 'Budget',
      value: totals?.budgetAmount,
      unit: TAKA_SYMBOL,
    },
    {
      key: 'disbursed',
      label: 'Disbursed',
      value: totals?.disburseAmount,
      unit: TAKA_SYMBOL,
    },
  ];
}
